export enum ApplicationPurpose {
  SELF_LEARNING_OR_CASUAL_EXPERIMENTATION = "Self learning / casual experimentation",
  SOLVING_PROBLEM_FOR_THE_COUNTRY_OR_FUNCTION_OR_TEAM = "Solving problem for the country / function / team",
  SPONSORED_BEACH_PROJECT = "Sponsored beach project",
  SPONSORED_CLIENT_PRE_SALES_OR_POC = "Sponsored client pre-sales / POC",
  HACKATHON = "Hackathon",
}
